import { Modal } from "antd";

export default function PopupModel({
	title,
	style,
	children,
	placement,
	closeIcon,
	open,
	onOk,
	onCancel,
	width,
	height,
	footer,
	zIndex,
}) {
	return (
		<Modal
			zIndex={zIndex}
			title={title}
			style={style}
			placement={placement}
			closeIcon={closeIcon}
			open={open}
			onOk={onOk}
			onCancel={onCancel}
			width={width}
			height={height}
			footer={footer}
		>
			{children}
		</Modal>
	);
}
